import { render, staticRenderFns } from "./SRCoverageIndicatorsReport.vue?vue&type=template&id=052e9121&"
import script from "./SRCoverageIndicatorsReport.vue?vue&type=script&lang=js&"
export * from "./SRCoverageIndicatorsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports